import Splide from "@splidejs/splide";

export const upcomingMatchesSliderInit = () => {
  const upcomingMatchesSliders = document.querySelectorAll('.upcoming-matches-slider');

  if(upcomingMatchesSliders) {
    upcomingMatchesSliders.forEach((item) => {
      const upcomingMatchesSlider = new Splide(item, {
        type: 'loop',
        perPage: 1,
			  perMove: 1,
        pagination: false,
			  gap: '24px',
        autoplay: false,
        rewind: true,
        speed: 600,
      });

      upcomingMatchesSlider.on( 'overflow', function ( isOverflow ) {
        upcomingMatchesSlider.go( 0 );

        upcomingMatchesSlider.options = {
          arrows    : isOverflow,
          pagination: isOverflow,
          drag      : isOverflow,
          clones    : isOverflow ? undefined : 0,
        };
      } );

      upcomingMatchesSlider.mount();
    });
  }
}